import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ActionSheetController, ToastController } from 'ionic-angular';
import { Chart } from "chart.js";


/**
 * Generated class for the CreateClubStandalonePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'sondages-results',
    templateUrl: 'sondages-results.html',
})
export class SondageResultsPage {

    @ViewChild("answerCanvas") answerCanvas: ElementRef;
    private answerCanvasChart: Chart;

    sondageData: any;
    answersArray : any = [];
    showGraph : boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public actionSheetCtrl: ActionSheetController,
        public toastCtrl: ToastController) {
        this.sondageData = this.navParams.get('sondageData');
    }

    ngOnInit(){
        this.sondageData.Answers.forEach(answers => {
            answers.option_value !== null ? this.answersArray.push(answers.option_value) : null;
        });
        if(this.sondageData.type !== 4){
            this.showGraph = true;
            this.generateChart(this.arrayGroupCount(this.answersArray))
        }
    }

    arrayGroupCount(arr) {
        var a = [], b = [], prev;
        
        arr.sort();
        for ( var i = 0; i < arr.length; i++ ) {
            if ( arr[i] !== prev ) {
                a.push(arr[i]);
                b.push(1);
            } else {
                b[b.length-1]++;
            }
            prev = arr[i];
        }
        return [a, b];
    }



    dismiss() {
        this.viewCtrl.dismiss();
    }

    // Charts

    generateChart(data){
        this.answerCanvasChart = new Chart(this.answerCanvas.nativeElement, {
            type: "bar",
            data: {
              labels: data[0],
              datasets: [
                {
                  label: "Réponse",
                  fill: true,
                  lineTension: 0.1,
                  borderColor: "rgba(17,139, 216, 0.4)",
                  borderCapStyle: "butt",
                  borderDash: [],
                  backgroundColor: ["#DBEAF1", "#AED3E5", "#2787B7", "#035D8F", "#024669", "#024669", "#AED3E5"],
                  borderDashOffset: 0.0,
                  borderJoinStyle: "miter",
                  pointBorderColor: "rgba(17,139, 216, 0.4)",
                  pointBackgroundColor: "rgba(17,139, 216, 0.4)",
                  pointBorderWidth: 1,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: "rgba(17,139, 216, 0.4)",
                  pointHoverBorderColor: "rgba(220,220,220,1)",
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: data[1],
                  spanGaps: false
                }
              ]
            },
            options: {
              legend: {
                display: false,
              },
              tooltips: {
                displayColors: false,
                enabled: false,
              },
              scales: {
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                  },
                  ticks: {
                    stepSize: 1,
                    beginAtZero: true,
                    min: 0
                  }
                }],
              },
              tooltipTemplate: "<%= value %>",
              onAnimationComplete: function () {
                this.showTooltip(this.datasets[0].bars);
              },
      
              tooltipEvents: [],
      
              showAllTooltips: true,
              responsive: true,
            }
          });
    }
    

}



// WEBPACK FOOTER //
// ./src/pages/employer/sondage/sondages-results/sondages-results.ts